<template>
    <div class="modal fade" id="modalEscortCallFeedback" tabindex="-1" role="dialog"
         aria-labelledby="modalEscortCallFeedbackTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content">

                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-center d-flex flex-column justify-content-center" v-if="escort">

                    <template v-if="!answerReceived">
                        <p class="call-feedback-question">
                            {{ translate.home.didAnswerCall1 }}
                            {{ escort.username }}
                            {{ translate.home.didAnswerCall2 }}
                        </p>

                        <button class="btn btn-secondary" @click="submitAnswer(1)">
                            {{ translate.home.yes }}
                        </button>

                        <button class="btn btn-primary mt-3" @click="submitAnswer(2)">
                            {{ translate.home.no }}
                        </button>

                        <p class="call-feedback-no-call mt-3" @click="submitAnswer(3)">
                            {{ translate.home.didNotCall }}
                        </p>

                    </template>

                    <template v-else>
                        <p class="call-feedback-thanks">{{ translate.home.thanksForFeedback }}</p>
                        <button class="btn btn-outline-secondary mt-3"
                                @click="closeModal"
                        >{{ translate.home.close }}
                        </button>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import localStorageMixin from "@/components/mixins/localStorageMixin";

const data = () => ({
    moment: moment,
    answerReceived: false,
    escort: null,
    timeWindowShouldBeInactiveSec: 6,
    timeAfterModalIsRedundantMin: 20,
});

function mounted() {
    this.removeEntryOnClose();
    if (window) {
        window.onfocus = () => {
            this.setLocalStorageListener();
        };
    }
}

function setLocalStorageListener() {
    if (!utils.isMobile()) {
        return;
    }

    const escortObject = this.getLocalStorageObject(this.escortCallFeedbackKey);

    if (escortObject && this.timeSpanIsRight(escortObject.time)) {
        this.escort = escortObject.user;
        this.showModal();
        return;
    }

    this.closeModal();
    this.deleteLocalStorageItem(this.escortCallFeedbackKey);
}

async function submitAnswer(answer_id) {
    this.answerReceived = true;

    const payload = {
        user_id: this.escort.id,
        answer_id
    }

    const [err, response] = await to(
        api.user.feedback.call.add(payload)
    );

    if (err || !_.get(response, 'data.success', false)) {
        return toastr.error(_.get(this, 'translate.home.errorCommon', ''));
    }

}

function removeEntryOnClose() {
    $("#modalEscortCallFeedback").on("hidden.bs.modal", (event) => {
        if (_.get(event, 'currentTarget.id', '') === 'modalEscortCallFeedback') {
            this.deleteLocalStorageItem(this.escortCallFeedbackKey);
            this.answerReceived = false;
        }
    });
}

function closeModal() {
    // the type check should solve the `s(...).modal is not a function` error
    // which happened on the "Fast 3G" connections (not always)
    // The modal itself still was functioning because this seemed to happening only
    // if the Jquery or Bootstrap (?) was still loading but the window.focus triggered
    // the `setLocalStorageListener` method and that called `closeModal`...
    //
    // The timeout initiation indicates that this was known issue before as well.
    if (typeof $("#modalEscortCallFeedback").modal !== 'undefined') {
        $("#modalEscortCallFeedback").modal('hide');
    }
}

function showModal() {
    if (utils.isMobile()) {
        $("#modalEscortCallFeedback").modal('show');
    }
}

function timeSpanIsRight(time) {
    return this.moment(time).clone().add(this.timeWindowShouldBeInactiveSec, 'seconds').isBefore(this.moment())
        && (!this.moment(time).clone().add(this.timeAfterModalIsRedundantMin, 'minutes').isBefore(this.moment()))
}

export default {
    data,
    mounted,
    beforeDestroy() {
        window.clearModalFade();
    },
    computed: {
        ...mapState(['translate'])
    },
    mixins: [localStorageMixin],
    methods: {
        submitAnswer,
        closeModal,
        removeEntryOnClose,
        showModal,
        setLocalStorageListener,
        timeSpanIsRight,
    }
};
</script>
